const PHRASES = [
  "Making the Kingdom Visible Where People Scroll",
  "Digital Ministry",
  "Kingdom Visibility",
  "Community Impact",
  "Preach Beyond Sunday",
  "Be Seen · Be Heard · Be Found",
];

export default function Marquee() {
  const row = [...PHRASES, ...PHRASES];
  return (
    <div className="border-y border-gold/20 bg-navy-surface/60 py-5 overflow-hidden" data-testid="editorial-marquee">
      <div className="marquee-track flex whitespace-nowrap w-max">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center" aria-hidden={half === 1}>
            {row.map((p, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-faith text-xs sm:text-sm tracking-[0.3em] uppercase text-white/55 px-6">{p}</span>
                <span className="text-gold text-sm">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
